import { NavItem } from './nav-item/nav-item';

/**
 * Menú lateral por módulos de producto: Transitorios / Abonados / Acceso / Finanzas
 * (+ Configuración, Herramientas, SuperAdmin). Rutas y permisos por ítem se mantienen.
 */
export const navItems: NavItem[] = [
  {
    displayName: 'Inicio',
    iconName: 'home',
    bgcolor: 'transparent',
    route: '/dashboards/default',
  },
  {
    displayName: 'Detecciones',
    iconName: 'camera',
    bgcolor: 'transparent',
    route: '/apps/Detection',
    permission: 'Cameras.GetAll',
  },

  { navCap: 'Transitorios', navCapEmphasis: true },

  {
    displayName: 'Tablero',
    iconName: 'layout-dashboard',
    bgcolor: 'transparent',
    route: '/dashboards/dashboard1',
  },

  {
    displayName: 'Operar',
    iconName: 'cash',
    bgcolor: 'secondary',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Ocupación',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/ParkingOccupancy',
        permission: 'ParkingOccupancy.View',
      },
      {
        displayName: 'Revisar categorías',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/category-review',
        permission: 'ParkingOccupancy.View',
      },
      {
        displayName: 'Paso Libre',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/authorized-vehicles',
        permission: 'AuthorizedVehicles.Create',
      },
      {
        displayName: 'Pago con Ticket',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/PayDetection',
        permission: 'ParkingPayment.Create',
      },
      {
        displayName: 'Historial de Sesiones',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/parking-sessions',
        permission: 'ParkingSessions.GetAll',
      },
      {
        displayName: 'Incidentes',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/parking-incidents',
        cashBoxSupervisionNav: true,
      },
    ],
  },

  {
    displayName: 'Tarifas y pases',
    iconName: 'currency-dollar',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Tarifas',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/unified-tariffs',
        permission: 'Tariffs.GetAll',
      },
      {
        displayName: 'Productos de pase',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/pass-products',
        permission: 'Customers.GetAll',
      },
      {
        displayName: 'Categorías de vehículo',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/vehicle-categories',
        permission: 'VehicleCategories.GetAll',
      },
    ],
  },

  { navCap: 'Abonados', navCapEmphasis: true },

  {
    displayName: 'Tablero',
    iconName: 'layout-dashboard',
    bgcolor: 'transparent',
    route: '/dashboards/dashboard2',
    permission: 'Dashboards.GetAll',
  },

  {
    displayName: 'Clientes',
    iconName: 'users',
    bgcolor: 'primary',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Gestión de Clientes',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/customers',
        permission: 'Customers.GetAll',
      },
      {
        displayName: 'Ficha de Cliente',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/customer-account',
        permission: 'Customers.GetById',
      },
      {
        displayName: 'Reporte de Deudores',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/customers/debtors',
        permission: 'Customers.GetAll',
      },
      {
        displayName: 'Vehículos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/vehicles',
        permission: 'Vehicles.GetAll',
      },
    ],
  },

  {
    displayName: 'Facturación Pendiente',
    iconName: 'receipt-tax',
    bgcolor: 'transparent',
    route: '/apps/billing-suggestions',
    permission: 'BillingSuggestions.GetAll',
  },

  {
    displayName: 'Comunicaciones',
    iconName: 'message',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Comunicaciones',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/communications',
        permission: 'Communications.GetAll',
      },
      {
        displayName: 'Plantillas de Notificación',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/notification-templates',
        permission: 'NotificationTemplates.GetAll',
      },
      {
        displayName: 'Mensajería',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/settings/messaging',
        permission: 'TenantMessagingConfig.Update',
      },
    ],
  },

  {
    displayName: 'Espacios',
    iconName: 'map-pin',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Planes',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/plans',
        permission: 'Plans.GetAll',
      },
      {
        displayName: 'Plazas',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/plazas',
        permission: 'Spaces.GetAll',
      },
    ],
  },

  { navCap: 'Acceso', navCapEmphasis: true, requiresParkingProfile: 'Acceso' },

  {
    displayName: 'Tablero',
    iconName: 'layout-dashboard',
    bgcolor: 'transparent',
    route: '/dashboards/access-control',
    permission: 'Dashboards.GetAll',
    requiresParkingProfile: 'Acceso',
  },

  {
    displayName: 'Vehículos Denegados',
    iconName: 'shield-lock',
    bgcolor: 'transparent',
    route: '/apps/denied-vehicles',
    permission: 'DeniedVehicles.GetAll',
    requiresParkingProfile: 'Acceso',
  },

  {
    displayName: 'Visitantes',
    iconName: 'users',
    bgcolor: 'transparent',
    route: '/apps/visitor-invitations',
    permission: 'VisitorInvitations.GetAll',
    requiresParkingProfile: 'Acceso',
  },

  {
    displayName: 'Control de Barrera',
    iconName: 'shield-lock',
    bgcolor: 'transparent',
    route: '/apps/gate-control',
    permission: 'GateControl.Execute',
    requiresParkingProfile: 'Acceso',
  },

  { navCap: 'Finanzas', navCapEmphasis: true },

  {
    displayName: 'Tablero financiero',
    iconName: 'layout-dashboard',
    bgcolor: 'transparent',
    route: '/dashboards/consolidated',
    permission: 'FinancialDashboard.GetAll',
  },

  {
    displayName: 'Caja',
    iconName: 'report-money',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Cajas',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/CashBoxes',
        permission: 'CashBox.GetAll',
      },
      {
        displayName: 'Planilla de Caja',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/CashMovements',
        permission: 'CashMovement.Create',
      },
      {
        displayName: 'Cierres de Caja',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/CashOperationsLogs',
        permission: 'CashBox.GetAll',
      },
      {
        displayName: 'Puntos de Venta',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/sales-points',
        permission: 'SalesPoints.GetAll',
      },
    ],
  },

  {
    displayName: 'Comprobantes',
    iconName: 'receipt-tax',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Facturación Manual',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/manual-invoice',
        permission: 'Taxes.GetAll',
      },
      {
        displayName: 'Libro de ventas',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/invoices-book',
        permission: 'Taxes.GetAll',
      },
      {
        displayName: 'Notas de Crédito',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/credit-notes-book',
        permission: 'Taxes.GetAll',
      },
      {
        displayName: 'Cierre de mes',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/month-close',
        permission: 'Taxes.GetAll',
      },
    ],
  },

  {
    displayName: 'Compras',
    iconName: 'shopping-cart',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Libro de compras',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/purchase-invoices-book',
        permission: 'PurchaseInvoices.GetAll',
      },
      {
        displayName: 'Proveedores',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/suppliers',
        permission: 'PurchaseInvoices.GetAll',
      },
      {
        displayName: 'Ficha de proveedor',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/supplier-account',
        permission: 'PurchaseInvoices.GetAll',
      },
    ],
  },

  {
    displayName: 'Impuestos y pagos',
    iconName: 'percentage',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Impuestos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/taxes',
        permission: 'Taxes.GetAll',
      },
      {
        displayName: 'Métodos de Pago',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/payment-methods',
        permission: 'Payments.Create',
      },
      {
        displayName: 'Tipo de Gastos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/expense-categories',
        permission: 'ExpenseCategory.GetAll',
      },
    ],
  },

  { navCap: 'Configuración' },

  {
    displayName: 'Dispositivos',
    iconName: 'device-analytics',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Cámaras',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/Cameras',
        permission: 'Cameras.GetAll',
      },
      {
        displayName: 'Lista de Dispositivos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/devices',
        permission: 'Cameras.GetAll',
      },
      {
        displayName: 'Configuración Dispositivo',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/device-configuration',
        permission: 'DeviceConfigurations.GetAll',
      },
      {
        displayName: 'Logs de Dispositivos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/device-logs',
        permission: 'Cameras.GetAll',
      },
    ],
  },

  {
    displayName: 'Seguridad y Usuarios',
    iconName: 'user-shield',
    bgcolor: 'transparent',
    defaultExpanded: false,
    children: [
      {
        displayName: 'Usuarios',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/users',
        permission: 'Users.GetAll',
      },
      {
        displayName: 'Roles',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/roles',
        permission: 'Roles.GetAll',
      },
      {
        displayName: 'Tipos de Asociación',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/vehicle-owner-types',
        permission: 'VehicleOwnerTypes.GetAll',
      },
    ],
  },

  {
    displayName: 'Emparejar salidas',
    iconName: 'settings-2',
    bgcolor: 'transparent',
    route: '/apps/settings/matching',
    permission: 'DeviceConfigurations.GetAll',
  },

  {
    displayName: 'Mi organización',
    iconName: 'settings',
    bgcolor: 'transparent',
    route: '/apps/tenant-organization',
    tenantAdminOnly: true,
  },

  { navCap: 'Herramientas' },
  {
    displayName: 'Tablero de Tareas',
    iconName: 'layout-kanban',
    bgcolor: 'primary',
    route: '/apps/board-tasks',
  },
  {
    displayName: 'Asistente Analítico',
    iconName: 'message-chatbot',
    bgcolor: 'secondary',
    route: '/apps/analyst',
  },

  { navCap: 'SuperAdmin', navCapSuperAdminOnly: true },
  {
    displayName: 'SuperAdmin',
    iconName: 'building-skyscraper',
    bgcolor: 'transparent',
    permission: 'Tenant.GetAll',
    superAdminOnly: true,
    defaultExpanded: false,
    children: [
      {
        displayName: 'Gestión de Tenants',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/tenants',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Inventario Maestro',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/inventory',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Simulador ALPR',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/simulator',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Curación y Entrenamiento',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/training-curation',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Entrenamiento',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/training-datasets',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Cajas de patente',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/plate-box-curation',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Catálogo Global de Vehículos',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/global-vehicle-categories',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
      {
        displayName: 'Plantillas por Defecto',
        iconName: 'point',
        bgcolor: 'transparent',
        route: '/apps/default-notification-templates',
        permission: 'Tenant.GetAll',
        superAdminOnly: true,
      },
    ],
  },
];
